import { render, staticRenderFns } from "./error.vue?vue&type=template&id=11341be5"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11341be5')) {
      api.createRecord('11341be5', component.options)
    } else {
      api.reload('11341be5', component.options)
    }
    module.hot.accept("./error.vue?vue&type=template&id=11341be5", function () {
      api.rerender('11341be5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/error.vue"
export default component.exports